import { baromoneyService } from '@/services';
import { mutationType } from './mutations';
const actionType = {
    // 필터옵션(조회기간) 수정
    setFilterOption: 'setFilterOption',
    // 정렬옵션 수정
    setSortOption: 'setSortOption',
    // 페이지 넘버 수정 - 필터옵션과는 분리 (필터옵션 deep 변경시 넘버 초기화를 위함)
    setPageNumber: 'setPageNumber',
    // 다이얼로그 열기/닫기
    setDialogDetail: 'setDialogDetail',
    // 라이더별 바로머니 내역 조회
    getWorkerBaromoneyHistoryByWorkerCodeList: 'getWorkerBaromoneyHistoryByWorkerCodeList',
    // 라이더별 바로머니 내역 목록 초기화
    resetWorkerBaromoneyHistoryByWorkerCodeList: 'resetWorkerBaromoneyHistoryByWorkerCodeList',
    // 전체 초기화
    resetStore: 'resetStore',
};
const actions = {
    [actionType.setFilterOption]({ commit }, payload) {
        commit(mutationType.SET_FILTER_OPTION, payload);
    },
    [actionType.setSortOption]({ commit }, payload) {
        commit(mutationType.SET_SORT_OPTION, payload);
    },
    [actionType.setPageNumber]({ commit }, pageNumber) {
        commit(mutationType.SET_PAGE_NUMBER, pageNumber);
    },
    [actionType.setDialogDetail]({ commit }, payload) {
        commit(mutationType.SET_DIALOG_DETAIL, payload);
    },
    async [actionType.getWorkerBaromoneyHistoryByWorkerCodeList]({ commit, state }) {
        const { hubId, workerCode, } = state.dialogDetail;
        if (!hubId || !workerCode) {
            return;
        }
        const payload = {
            hubId,
            fromDate: state.filterOption.fromDate.replaceAll('-', ''),
            toDate: state.filterOption.toDate.replaceAll('-', ''),
            pageSize: state.pageSize,
            pageNumber: state.pageNumber,
            sortOption: state.sortOption,
        };
        try {
            const response = await baromoneyService.getWorkerBaromoneyHistoryByWorkerCode(workerCode, payload);
            commit(mutationType.GET_WORKER_PROFIT_BY_WORKER_CODE_LIST, response);
        }
        catch (error) {
            console.log('getWorkerBaromoneyHistoryByWorkerCodeList', error);
        }
    },
    [actionType.resetWorkerBaromoneyHistoryByWorkerCodeList]({ commit }) {
        commit(mutationType.RESET_WORKER_PROFIT_BY_WORKER_CODE_LIST);
    },
    [actionType.resetStore]({ commit }) {
        commit(mutationType.RESET_STORE);
    },
};
export default actions;
